import React, { useEffect, useState} from "react";

const ScheduledAppointmentReminderAlert = ({ appointment, formHandler }) => {
  const [showPopUp, setShowPopUp] = useState(false);

  const ScheduledAppointmentReminderPopUp = ({formHandler}) => {
    return(
      <>
        <div className={'scheduled-appt-pop-up panel panel-default'}>
          <div className={'panel-header text-center'}>
            <b><i className={'fa fa-exclamation-circle'}></i> Confirm Future Appointments</b>
            <i onClick={(el) => setShowPopUp(false) } className={'fa fa-times scheduled-appt-pop-up-close-btn float-right'}></i>
          </div>
          <div className={'panel-body'}>
            Check your records. If the patient has a future appointment scheduled with your PCP Group, create an <b>Appointment Scheduled Task</b> so we can track it!
            <br className={'m-t-lg'}/>
            <a className={'m-t-lg btn btn-default'} href={'/physicians/tasks/new'} target='_blank'>Click to create Appointment Scheduled Task</a>
          </div>
        </div>
      </>
    )
  }

  return(
    <>
      <div className={'m-t-lg'}>
        {
          showPopUp == true && (<>
            <ScheduledAppointmentReminderPopUp />
          </>)
        }
        <b> Does this patient have a future appointment scheduled with your PCP group?
          <br />
          Click <a onClick={() => setShowPopUp(true) }>here</a> if they do.
        </b>
      </div>
    </>
  )
}

export default ScheduledAppointmentReminderAlert;
